import React, { useState, useEffect } from 'react';
import axios from 'axios';
import apiURL from './Config';

const RatesComponent = () => {
  const [rates, setRates] = useState({});
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');

  useEffect(() => {
    // Fetch current rates from the server
    axios.get(`${apiURL}/api/rates`)
      .then(response => {
        setRates(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching rates:', error);
        setLoading(false);
      });
  }, []);

  const handleChange = (region, key, value) => {
    setRates(prevRates => ({
      ...prevRates,
      [region]: {
        ...prevRates[region],
        [key]: parseFloat(value)
      }
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios.post(`${apiURL}/api/rates`, rates, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    })
      .then(response => {
        setMessage(response.data.message);
        alert('Rates updated successfully!');
      })
      .catch(error => {
        console.error('Error updating rates:', error);
        setMessage('Error updating rates');
      });
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className='main-content'>
      <div className='rates'>
        <h2>Update Shipping Rates</h2>
        {message && <p>{message}</p>}
        <form onSubmit={handleSubmit}>
          <table style={{ 
            width: '100%', 
            borderCollapse: 'collapse', 
            marginBottom: '20px',
            border: '1px solid #ddd'
          }}>
            <thead>
              <tr style={{ backgroundColor: '#f5f5f5' }}>
                <th style={{ 
                  padding: '12px', 
                  textAlign: 'left', 
                  border: '1px solid #ddd',
                  fontWeight: 'bold'
                }}>Region</th>
                <th style={{ 
                  padding: '12px', 
                  textAlign: 'center', 
                  border: '1px solid #ddd',
                  fontWeight: 'bold'
                }}>0-250g</th>
                <th style={{ 
                  padding: '12px', 
                  textAlign: 'center', 
                  border: '1px solid #ddd',
                  fontWeight: 'bold'
                }}>251-500g</th>
                <th style={{ 
                  padding: '12px', 
                  textAlign: 'center', 
                  border: '1px solid #ddd',
                  fontWeight: 'bold'
                }}>501-1000g</th>
                <th style={{ 
                  padding: '12px', 
                  textAlign: 'center', 
                  border: '1px solid #ddd',
                  fontWeight: 'bold'
                }}>Additional per 500g</th>
              </tr>
            </thead>
            <tbody>
              {Object.keys(rates).map(region => (
                <tr key={region}>
                  <td style={{ 
                    padding: '12px', 
                    border: '1px solid #ddd',
                    fontWeight: 'bold',
                    backgroundColor: '#f9f9f9'
                  }}>{region}</td>
                  <td style={{ 
                    padding: '12px', 
                    border: '1px solid #ddd',
                    textAlign: 'center'
                  }}>
                    <input
                      type="number"
                      value={rates[region].amount250}
                      onChange={(e) => handleChange(region, 'amount250', e.target.value)}
                      style={{ 
                        padding: '8px', 
                        width: '80px',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        textAlign: 'center'
                      }}
                    />
                  </td>
                  <td style={{ 
                    padding: '12px', 
                    border: '1px solid #ddd',
                    textAlign: 'center'
                  }}>
                    <input
                      type="number"
                      value={rates[region].amount500}
                      onChange={(e) => handleChange(region, 'amount500', e.target.value)}
                      style={{ 
                        padding: '8px', 
                        width: '80px',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        textAlign: 'center'
                      }}
                    />
                  </td>
                  <td style={{ 
                    padding: '12px', 
                    border: '1px solid #ddd',
                    textAlign: 'center'
                  }}>
                    <input
                      type="number"
                      value={rates[region].amount1000}
                      onChange={(e) => handleChange(region, 'amount1000', e.target.value)}
                      style={{ 
                        padding: '8px', 
                        width: '80px',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        textAlign: 'center'
                      }}
                    />
                  </td>
                  <td style={{ 
                    padding: '12px', 
                    border: '1px solid #ddd',
                    textAlign: 'center'
                  }}>
                    <input
                      type="number"
                      value={rates[region].additional500}
                      onChange={(e) => handleChange(region, 'additional500', e.target.value)}
                      style={{ 
                        padding: '8px', 
                        width: '80px',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        textAlign: 'center'
                      }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <button type="submit" style={{
            backgroundColor: '#007bff',
            color: 'white',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '16px'
          }}>Update Rates</button>
        </form>
      </div>
    </div>
  );
};

export default RatesComponent;